import * as React from 'react'

function PlusWhite(props) {
    return (
        <svg
            width={18}
            height={18}
            fill="#fff"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2 1.5a1.5 1.5 0 10-3 0v5.7H1.5a1.5 1.5 0 100 3h5.7v5.7a1.5 1.5 0 003 0v-5.7h5.7a1.5 1.5 0 000-3h-5.7V1.5z"
                //fill='#fff'
            />
        </svg>
    )
}

export default PlusWhite
